import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=1ec4a699&"
var script = {}
import style0 from "./LogoComponent.vue?vue&type=style&index=0&id=1ec4a699&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports